export const STATIC_FIRST_LEVEL_LINKS = [
  { to: "shop", title: { en: "Collection", de: "Collection" } },
  { to: "projects", title: { en: "Projects", de: "Projekte" } },
];

export const STATIC_SECOND_LEVEL_LINKS = [
  { to: "rawMaterials", title: { en: "Materials", de: "Materials" } },
];
